import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AboutSection from '../components/AboutSection.tsx';
import SEO from '../components/SEO';

const Aboutmonkstack = () => {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://monkstack.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'About',
        item: 'https://monkstack.com/about-monkstack',
      },
    ],
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'About monkStack',
    url: 'https://monkstack.com/about-monkstack',
    description:
      'monkStack is an AI and engineering studio in Pune. We design, build, and operate production software for founders and operators.',
  };

  return (
    <div className="App">
      <SEO
        title="About Us"
        description="monkStack is an AI and engineering studio in Pune. Five reasons builders and founders work with us: scalable delivery, senior ownership, and software that ships."
        url="https://monkstack.com/about-monkstack"
        structuredData={[breadcrumbSchema, aboutSchema]}
      />
      <Navbar />
      <AboutSection />
      <Footer />
    </div>
  );
};

export default Aboutmonkstack;
